import { encode } from "uqr";
import {
  renderMarkers
} from "./markers.js";
import {
  renderPixels
} from "./pixels.js";
import {
  getColors,
  getSize,
  getRadius,
  getVariant,
  DEFAULT_PIXEL_SIZE
} from "./utils.js";
export function renderSVG(data, options = {}) {
  const {
    radius,
    pixelSize,
    pixelPadding,
    variant,
    ...opts
  } = options;
  const result = encode(data, opts);
  const { width, height } = getSize(result.size, pixelSize);
  let svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">`;
  svg += renderSVGBody(result, options);
  svg += "</svg>";
  return svg;
}
export function renderSVGBody(result, options = {}) {
  const {
    radius,
    pixelSize = DEFAULT_PIXEL_SIZE,
    pixelPadding,
    variant,
    border
  } = options;
  const { backgroundColor, foregroundColor } = getColors(options);
  const { width, height } = getSize(result.size, pixelSize);
  let svgBody = `<rect fill="${backgroundColor}" width="${width}" height="${height}"/>`;
  const { pixelRadius, markerRadius } = getRadius(radius);
  const { pixelVariant, markerVariant } = getVariant(variant);
  svgBody += renderPixels(result, border, pixelSize, foregroundColor, pixelVariant, pixelRadius, pixelPadding);
  svgBody += renderMarkers(result, border, pixelSize, foregroundColor, markerVariant, markerRadius, pixelPadding);
  return svgBody;
}
